import { render, staticRenderFns } from "./riskTip.vue?vue&type=template&id=5937e97b&scoped=true"
import script from "./riskTip.vue?vue&type=script&lang=js"
export * from "./riskTip.vue?vue&type=script&lang=js"
import style0 from "./riskTip.vue?vue&type=style&index=0&id=5937e97b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5937e97b",
  null
  
)

export default component.exports